<template>
    <section>
        <top-banner banner-image="account-confirmation">
            <div class="flex items-center justify-center h-full">
                <div class="text-center pt-10">
                    <h3 class="text-center" v-text="$t('CONFIRMATION_WELCOME_TO')"></h3>
                    <img
                        src="@/assets/images/logos/freddies_flowers_stacked.svg"
                        alt="Freddie's Flowers"
                        class="h-16 md:h-32">

                    <!-- Tiny gap -->
                    <div class="clear--xs"></div>

                    <a href="#" v-scroll-to="'#content-start'">
                        <div class="icon--arrow-circle-down"></div>
                    </a>
                </div>
            </div>
        </top-banner>

        <!-- Small gap -->
        <div class="clear--sm"></div>

        <div id="content-start" class="max-w-sm mx-auto">
            <p class="text-center" v-text="$t('CONFIRMATION_WE_ARE_SO')"></p>
            <p class="text-center" v-html="$t('CONFIRMATION_BEFORE_YOU')"></p>

            <!-- Tiny gap -->
            <div class="clear--xs"></div>
            <div class="flex justify-center">
                <div>
                    <!-- Post checkout questions radio field -->
                    <div
                        v-for="postCheckoutQuestion in postCheckoutQuestions" :key="postCheckoutQuestion.id"
                        class="input__radio">
                        <input
                            :id="`post-checkout-question-${postCheckoutQuestion.id}`"
                            name="post-checkout-question"
                            class="input__radio-item"
                            type="radio"
                            :value="postCheckoutQuestion.name"
                            v-model="postCheckoutAnswer">
                        <label class="input__radio-label" :for="`post-checkout-question-${postCheckoutQuestion.id}`">
                            {{ postCheckoutQuestion.name }}
                        </label>
                    </div>

                    <!-- Tiny gap -->
                    <div class="clear--xs"></div>

                    <router-link :to="{ name: 'account.dashboard' }" class="btn btn--primary text-center">
                        {{ $t('CONFIRMATION_NEXT_STEP') }}
                    </router-link>
                </div>
            </div>
        </div>

        <iframe aria-hidden="true" src="https://apps.rokt.com/wsdk/preload/index.html" sandbox="allow-scripts allow-same-origin" style="border: 0px; width: 100%; display: none;"></iframe>

        <!-- Small gap -->
        <div class="clear--sm"></div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import TopBanner from '@/components/structure/TopBanner';
import PostCheckoutService from '@/services/users/PostCheckoutService';
import { gaConversion } from '@/helpers/GAHelpers';

let postCheckoutService = new PostCheckoutService();

export default {
    name: 'Confirmation',
    data() {
        return {
            isFormProcessing: false,
            postCheckoutAnswer: null,
            postCheckoutQuestions: [],
        };
    },
    mounted() {
        this.getPostCheckoutQuestions();
        this.sendOptimusMetrics();
        this.triggerRokt();
        gaConversion('conversion', process.env.VUE_APP_GOOGLE_ANALYTICS_SEND_TO, this.subscription.id);
    },
    beforeDestroy() {
        this.closeRokt();
    },
    computed: {
        ...mapGetters({
            userId: 'account/getUserId',
            email: 'account/getEmail',
            couponCode: 'account/getSignupCoupon',
            subscription: 'subscription/getActiveSubscription',
        }),
    },
    methods: {
        triggerRokt() {
            window.rokt && window.rokt.onLoaded((rokt) => {
                rokt.setAttributes({
                    email: this.email,
                    confirmationref: this.userId,
                });

                rokt.triggerPageChange({
                    pageIdentifier: 'confirmation.page',
                });
            });
        },
        closeRokt() {
            window.rokt && window.rokt.onLoaded((rokt) => {
                rokt.closeAll();
            });
        },
        sendOptimusMetrics() {
            const coupon = this.couponCode || null;
            const parsedImpactKey = Number(process.env.VUE_APP_IMPACT_KEY);

            ire('trackConversion', parsedImpactKey, {
                orderId: this.userId,
                orderPromoCode: coupon,
            });

            if (window.AWIN && window.AWIN.Tracking) {
                window.AWIN.Tracking.Sale = {};
                window.AWIN.Tracking.Sale.amount = '1';
                window.AWIN.Tracking.Sale.channel = 'aw';
                window.AWIN.Tracking.Sale.orderRef = this.userId;
                window.AWIN.Tracking.Sale.parts = `DEFAULT:1`;
                window.AWIN.Tracking.Sale.currency = 'GBP';
                window.AWIN.Tracking.Sale.voucher = coupon || '';
                window.AWIN.Tracking.Sale.test = process.env.VUE_APP_ENV === 'Production' ? '0' : '1';
                window.AWIN.Tracking.run();
            }

            let awPixel = new Image(0, 0);
            awPixel.src = `https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=${process.env.VUE_APP_AWIN_KEY}&amount=1&ch=aw&parts=DEFAULT:1&ref=${this.userId}${coupon ? '&vc=' + coupon : '&vc='}&cr=GBP&testmode=0`;
            document.body.appendChild(awPixel);
        },
        async getPostCheckoutQuestions() {
            this.postCheckoutQuestions = await postCheckoutService.getPostCheckoutQuestions();
            this.postCheckoutQuestions.sort(() => Math.random() - 0.5);
        },
        async saveUserPostCheckoutAnswer(postCheckoutAnswer) {
            await postCheckoutService.saveUserPostCheckoutAnswer(postCheckoutAnswer);
        },
    },
    watch: {
        postCheckoutAnswer(value) {
            this.saveUserPostCheckoutAnswer(value);
        },
    },
    components: {
        TopBanner,
    },
};
</script>
